import React from 'react';

const rowWrapSpcBtween = (): React.CSSProperties => {
  return {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'start',
  };
};

export default rowWrapSpcBtween;
